export default "__VITE_ASSET__611b0272__"